import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type { ResourceType } from 'types/resource-types';
import { type ApiError, type ApiResponse, useAxiosInstance } from './utils';
import { addActionNameToMutationResult } from './utils/add-action-name-to-mutation-result';

export async function updateViewFn(axiosInstance: Promise<AxiosInstance>, { viewId, name }: any) {
  const instance = await axiosInstance;
  return instance.put(`views/${viewId}`, { name });
}

export const useUpdateView = () => {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<
    ApiResponse,
    ApiError,
    { viewId: string; name: string; resourceType: ResourceType }
  >({
    mutationFn: variables => updateViewFn(axiosInstance, variables),
    onSuccess: (_response, { resourceType }) => {
      client.invalidateQueries({ queryKey: ['views', resourceType] });
    },
    onError: (_error, { resourceType }) => {
      client.invalidateQueries({ queryKey: ['views', resourceType] });
    },
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    { viewId: string; name: string; resourceType: ResourceType },
    'updateView'
  >('updateView', mutation);
};
